import clsx from "clsx"

import useHeightCSSVariable from "@hooks/useHeightCSSVariable"

import { Divider } from "@atoms"

import styles from "./PopoverHeader.module.scss"
import type { PopoverHeaderActionsProps, PopoverHeaderRootProps } from "./PopoverHeader.types"
import PopoverHeaderBackButton from "./PopoverHeaderBackButton/PopoverHeaderBackButton"
import PopoverHeaderCloseButton from "./PopoverHeaderCloseButton/PopoverHeaderCloseButton"
import PopoverHeaderTitle from "./PopoverHeaderTitle/PopoverHeaderTitle"

function PopoverHeaderRoot(props: PopoverHeaderRootProps) {
    const { className, children, showDivider = true } = props

    const headerRef = useHeightCSSVariable<HTMLDivElement>("--popover-header-height")

    return (
        <div ref={headerRef} className={clsx(styles.base, className)}>
            <div className={styles.innerContainer}>{children}</div>
            {showDivider && <Divider />}
        </div>
    )
}

function PopoverHeaderActions(props: PopoverHeaderActionsProps) {
    const { className, children } = props
    return <div className={clsx(styles.actionsSlot, className)}>{children}</div>
}

export default {
    Root: PopoverHeaderRoot,
    Title: PopoverHeaderTitle,
    Actions: PopoverHeaderActions,
    BackButton: PopoverHeaderBackButton,
    CloseButton: PopoverHeaderCloseButton,
}
